import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CertificatesListHeader} from './components/header/CertificatesListHeader'
import { CertificatesTable } from './table/CertificatesTable'
import { CertificateViewModal } from './certificate-view-modal/CertificateViewModal'
import { KTCard } from '../../../../_metronic/helpers'

const CertificatesList = () => {
  const {itemIdForUpdate} = useListView()

  return (
  <>
  <KTCard className="p-10">
    <CertificatesListHeader />
    <CertificatesTable />
  </KTCard>      
  {itemIdForUpdate !== undefined && <CertificateViewModal />}
  </>
  )
}

const SearchCertificatesWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <CertificatesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {SearchCertificatesWrapper}
